// Knygomatai Site Data - Lithuanian Translation
// All images from bibliomats.lv

export const BRAND = {
  name: "Knygomatai",
  tagline: "automatizuotos knygų atsiėmimo ir grąžinimo spintelės bibliotekoms",
  domain: "knygomatai.lt",
  logo: "/logo.png",
};

// Lithuanian flag colors
export const COLORS = {
  yellow: "#FDB913",
  green: "#006A44",
  red: "#C1272D",
  dark: "#1A1A1A",
  gray: "#6B6B6B",
  lightGray: "#DADADA",
  background: "#F7F7F5",
  white: "#FFFFFF",
};

export const NAV_ITEMS = [
  { label: "Apie mus", href: "#about" },
  { label: "Sprendimai bibliotekoms", href: "/sprendimai-bibliotekoms" },
  { label: "Produktai", href: "#products" },
  { label: "Kontaktai", href: "#contact" },
];

export const HERO = {
  title: "automatizuotos knygų atsiėmimo ir grąžinimo spintelės bibliotekoms",
  subtitle: "Pasiekiamos 24/7. Sukurtos bibliotekoms. Pagamintos Baltijos šalyse.",
  cta1: "Prašyti demonstracijos",
  cta2: "Įgyvendinti projektai",
};

export const ABOUT = {
  title: "Kas yra Knygomatai?",
  description: "Knygomatai® yra automatizuota knygų atsiėmimo ir grąžinimo sistema, užtikrinanti bibliotekos paslaugų prieinamumą 24 valandas per parą, 7 dienas per savaitę.",
  features: [
    {
      title: "Viešosioms ir akademinėms bibliotekoms",
      description: "Skirta įvairaus dydžio bibliotekoms",
      icon: "library",
    },
    {
      title: "Knygų atsiėmimas ir grąžinimas",
      description: "Paprastas ir greitas knygų skolinimosi procesas",
      icon: "book",
    },
    {
      title: "Vidaus ir lauko sprendimai",
      description: "Pritaikomi įvairioms aplinkoms",
      icon: "building",
    },
    {
      title: "Prieiga 24/7",
      description: "Pasiekiamumas bet kuriuo paros metu",
      icon: "clock",
    },
  ],
};

export const PRODUCTS = {
  title: "Knygų spintelių sprendimai bibliotekoms",
  subtitle: "Pasirinkite tinkamiausią automatizavimo sprendimą savo bibliotekos poreikiams",
  items: [
    {
      title: "Paprastasis knygomatas su grąžinimo dėže",
      description: "Kompaktiškas sprendimas su integruota knygų grąžinimo dėže. Idealus mažesnėms bibliotekoms.",
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/vvrng4f3_Vienk%C4%81r%C5%A1ais%20bibliom%C4%81ts%20ar%20nodo%C5%A1anas%20kasti.jpg",
      alt: "Paprastasis knygomatas su grąžinimo dėže bibliotekoms",
    },
    {
      title: "Paprastasis knygomatas be grąžinimo dėžės",
      description: "Ekonomiškas sprendimas tik knygų atsiėmimui. Tinka vietoms su atskiru grąžinimo punktu.",
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/y2pqefak_Vienk%C4%81r%C5%A1ais%20bibliom%C4%81ts%20bez%20nodo%C5%A1anas%20kastes.jpg",
      alt: "Paprastasis knygomatas be grąžinimo dėžės",
    },
    {
      title: "Dvigubas knygomatas su grąžinimo dėže",
      description: "Padidinta talpa su dvigubu skyrių skaičiumi. Tinka didesnėms bibliotekoms.",
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/4e1qlacb_Dubultais%20bibliom%C4%81ts%20ar%20nodo%C5%A1anas%20kasti.jpg",
      alt: "Dvigubas knygomatas su grąžinimo dėže didelėms bibliotekoms",
    },
    {
      title: "Dvigubas knygomatas be grąžinimo dėžės",
      description: "Didelės talpos sprendimas tik knygų atsiėmimui.",
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/nr1c6bsc_Dubultais%20bibliom%C4%81ts%20bez%20nodo%C5%A1anas%20kastes.jpg",
      alt: "Dvigubas knygomatas be grąžinimo dėžės",
    },
    {
      title: "Grąžinimo dėžė",
      description: "Atskira knygų grąžinimo dėžė. Galima naudoti su bet kuriuo knygomato sprendimu.",
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/zanv6mwg_Nodo%C5%A1anas%20kaste.jpg",
      alt: "Knygų grąžinimo dėžė bibliotekoms",
    },
    {
      title: "Grąžinimo dėžė su vidine amortizacija",
      description: "Patobulinta grąžinimo dėžė su specialia amortizacijos sistema knygų apsaugai.",
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/8932qypa_Nodo%C5%A1anas%20kaste%20ar%20iek%C5%A1%C4%93jo%20amortiz%C4%81ciju.jpg",
      alt: "Grąžinimo dėžė su amortizacija knygų apsaugai",
    },
  ],
  seeAllSolutions: "Peržiūrėti visus sprendimus bibliotekoms",
};

export const VIDEO = {
  title: "Kaip tai veikia?",
  subtitle: "Žiūrėkite vaizdo įrašą ir sužinokite, kaip paprasta naudotis Knygomatais®",
};

export const CLIENTS = {
  title: "Jie mumis pasitiki",
  subtitle: "Knygomatai® sprendimai jau sėkmingai veikia Latvijos ir Lietuvos bibliotekose.",
  subheading: "Veikia šiuose miestuose",
  logos: [
    // Lithuanian libraries
    { name: "Kauno Vinco Kudirkos Viešoji Biblioteka", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/jhsq80bs_logo-fb.jpg" },
    { name: "Vilniaus Apskrities Adomo Mickevičiaus Viešoji Biblioteka", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/bk78eass_Adamo.png" },
    { name: "Druskininkų Savivaldybės Viešoji Biblioteka", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/92jfyyg5_Ekrano%20nuotrauka%202023-11-06%20163949.jpg" },
    { name: "Elektrėnų Savivaldybės Viešoji Biblioteka", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/ikdycgn7_Elektreniai.png" },
    { name: "Vilniaus Universitetas", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/z411fcd6_Logo-Vilnius-University-big.png" },
    { name: "Mažeikių Henriko Nagio Viešoji Biblioteka", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/3zpiefoj_Mazeikiai.png" },
    { name: "J. Paukštelio Viešoji Biblioteka Pakruojis", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/qkzbc9wg_Pakruojis.png" },
    { name: "Marijampolės Petro Kriaučiūno Viešoji Biblioteka", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/xu0seuz9_petro-kriauciuno-300x300.png" },
    { name: "Rietavo Savivaldybės Viešoji Biblioteka", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/u96lqrsf_rietavo.png" },
    { name: "Šiaulių Apskrities Povilo Višinskio Viešoji Biblioteka", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/k0z93ed0_SAVB_logotipas.jpg" },
    { name: "Trakų Viešoji Biblioteka", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/fjddgx03_Trakai.png" },
    { name: "Vilniaus Dizaino Kolegija", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/vsz99s41_Vilnio%20Designo.png" },
    { name: "Vrublevskių Biblioteka", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/0zj3hehs_Vrub.jpg" },
    // Latvian libraries
    { name: "Ulbrokas Bibliotēka", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/3aqcyysr_UB_krasains.gif" },
    { name: "Latgales Centrālā Bibliotēka", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/wzk4mwkx_Latgale.jpg" },
    { name: "Latvijas Nacionālās bibliotēkas Atbalsta Biedrība", image: "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/tgetgwgl_lnb_ab_logo_grey_cs_1.jpg" },
    { name: "Bauska", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/vuakqcsh_bauska.png" },
    { name: "Cēsis", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/b0uu0t6y_Cesis.png" },
    { name: "Rīga", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/l697z950_download.jpg" },
    { name: "Jelgava", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/2or5vthm_Jelgava.png" },
    { name: "Kuldīga", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/eyn2vad6_Kuldiga.png" },
    { name: "Mārupe", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/833p47nr_Marupe.png" },
    { name: "Preiļi", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/4lgb3z8w_Preili.jpg" },
    { name: "Liepāja", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/wk33kt64_Liepaja.png" },
    { name: "Rīga Logo", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/hbhffapi_Logo_Riga.png" },
    { name: "Mārupe Biblio", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/fc28bc21_Marupe%20Biblio.png" },
    { name: "Rēzekne", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/fes1jdhk_Rezekne.jpg" },
    { name: "Talsi", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/b21ds72i_Talsi.png" },
    { name: "Valka", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/ab1cyv5z_Valka.png" },
    { name: "Valmiera", image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/s64o7sxs_Valmiera.png" },
  ],
};

export const USE_CASES = {
  title: "Kur naudojamas Knygomatai®?",
  subtitle: "Išbandyta įvairiuose viešuose ir švietimo kontekstuose visoje Latvijoje ir Lietuvoje.",
  items: [
    {
      title: "Bibliotekos",
      description: "Viduje, prie įėjimo arba vestibiulyje",
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/ig76x93z_Bibliot%C4%93kas.jpeg",
      alt: "Knygomatas bibliotekoje prie įėjimo",
    },
    {
      title: "Transporto mazgai",
      description: "Stotyse ir vietose su dideliu žmonių srautu",
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/lugupkic_Transporta%20mezgli.jpeg",
      alt: "Knygomatas transporto mazge",
    },
    {
      title: "Prekybos centrai",
      description: "Knygų atsiėmimas ne bibliotekos darbo metu",
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/8vzw1st7_Tirdzniec%C4%ABbas%20centri.jpg",
      alt: "Knygomatas prekybos centre",
    },
    {
      title: "Lauko įrengimai",
      description: "Veikia su baterijomis, be elektros prijungimo",
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/c88siq6k_%C4%80ra%20uzst%C4%81d%C4%ABjumi.jpeg",
      alt: "Lauko knygomatas su baterijomis",
    },
    {
      title: "Naktinė prieiga",
      description: "Saugus naudojimas 24/7 su apšvietimu",
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/ni0kh2y2_Nakts%20piek%C4%BCuve.jpeg",
      alt: "Knygomatas naktį su apšvietimu 24/7",
    },
    {
      title: "Universitetai ir mokyklos",
      description: "Studentams ir dėstytojams bet kuriuo metu",
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/cikpc2fq_Universit%C4%81tes%20un%20skolas.jpeg",
      alt: "Knygomatas universitete studentams",
    },
  ],
};

export const FEATURES = {
  title: "Bibliotekų automatizavimo funkcionalumas",
  subtitle: "Moderni technologija jūsų bibliotekos poreikiams",
  items: [
    { title: "Jutiklinis ekranas", description: "Intuityvus naudotojo interfeisas", icon: "monitor" },
    { title: "QR kodo prieiga", description: "Greita ir patogi autentifikacija", icon: "qr" },
    { title: "Bibliotekos kortelė", description: "Tradicinis prieigos metodas", icon: "card" },
    { title: "SMS / skaitmeninis kodas", description: "Alternatyvi prieigos galimybė", icon: "sms" },
    { title: "Naudojimo statistika", description: "Išsamūs duomenys apie naudojimą", icon: "chart" },
    { title: "Saugumas", description: "Apsaugota nuo vandalizmo", icon: "shield" },
  ],
  cta: "Kitos galimybės? Susisiekite su mumis",
  seeAllLink: "Peržiūrėti visus bibliotekų technologinius sprendimus",
};

export const FAQ = {
  title: "Dažnai užduodami klausimai",
  subtitle: "Atsakymai į dažniausiai užduodamus klausimus",
  items: [
    {
      question: "Kur galima įrengti Knygomatą?",
      answer: "Knygomatus galima įrengti tiek viduje, tiek lauke. Jie tinka bibliotekoms, prekybos centrams, transporto mazgams, universitetams ir kitoms viešosioms erdvėms.",
    },
    {
      question: "Ar Knygomatas gali veikti su baterijomis?",
      answer: "Taip, lauko įrengimai gali veikti su baterijomis be elektros prijungimo, kas leidžia juos įrengti bet kurioje vietoje.",
    },
    {
      question: "Kiek saugus yra Knygomatas?",
      answer: "Knygomatas yra apsaugotas nuo vandalizmo ir sukurtas saugiam naudojimui viešose vietose 24/7.",
    },
    {
      question: "Ar pasiekiamas 24/7?",
      answer: "Taip, Knygomatas veikia visą parą, septynias dienas per savaitę, leisdamas bibliotekos lankytojams atsiimti ir grąžinti knygas bet kuriuo metu.",
    },
    {
      question: "Ar yra prieinama naudojimo statistika?",
      answer: "Taip, sistema teikia išsamius naudojimo statistikos duomenis, padedančius bibliotekoms geriau planuoti ir optimizuoti paslaugas.",
    },
    {
      question: "Kokios prieigos metodai yra prieinami?",
      answer: "Prieinami įvairūs prieigos metodai: jutiklinis ekranas, QR kodas, bibliotekos kortelė, SMS kodas arba skaitmeninis kodas.",
    },
  ],
};

export const CONTACT = {
  title: "Susisiekite su mumis",
  subtitle: "Užpildykite formą ir mes su jumis susisieksime artimiausiu metu.",
  benefits: {
    title: "Kodėl rinktis Knygomatai®?",
    items: [
      "Pasiekiamas 24/7",
      "Pagaminta Baltijos šalyse",
      "Profesionali pagalba",
      "Pritaikomi sprendimai",
    ],
  },
  form: {
    organization: "Įmonė / organizacija",
    name: "Vardas",
    email: "El. paštas",
    phone: "Telefonas",
    message: "Žinutė",
    submit: "Siųsti užklausą",
    success: "Ačiū! Jūsų užklausa buvo išsiųsta sėkmingai.",
    error: "Klaida siunčiant užklausą. Bandykite dar kartą.",
  },
};

export const FOOTER = {
  copyright: `© ${new Date().getFullYear()} Knygomatai®. Visos teisės saugomos.`,
  links: [
    { label: "Pradžia", href: "/" },
    { label: "Sprendimai", href: "/sprendimai-bibliotekoms" },
    { label: "Kontaktai", href: "#contact" },
  ],
};

// Solutions Page Data
export const SOLUTIONS_PAGE = {
  metaTitle: "Sprendimai bibliotekoms | Automatizavimas, RFID, įranga",
  metaDescription: "Technologiniai sprendimai bibliotekoms ir savivaldybėms: knygų spintelės, RFID, automatizavimas, inventorizacija, įranga ir palaikymas.",
  title: "Technologiniai sprendimai bibliotekoms",
  subtitle: "Nuo 2019 metų teikiame technologinius sprendimus bibliotekoms, savivaldybėms ir viešosioms įstaigoms Latvijoje ir Baltijos šalyse. Siūlome tiek atskirus produktus, tiek kompleksinius bibliotekų infrastruktūros sprendimus, pritaikytus kiekvienos įstaigos poreikiams ir esamai sistemų aplinkai.",
  sectionTitle: "Sprendimai bibliotekoms ir savivaldybėms",
  sectionSubtitle: "Pasirinkite automatizavimo sprendimą, atitinkantį jūsų bibliotekos poreikius",
  solutions: [
    {
      title: "Knygų spintelės (Knygomatai®)",
      features: ["Atsiėmimas ir grąžinimas 24/7", "Vidaus ir lauko įrengimams", "Pritaikoma bibliotekų poreikiams"],
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/nistqpb9_Collage_Fotor-1-1920x1080.jpg",
      alt: "Knygomatai knygų spintelės bibliotekoms",
      seoDescription: "Automatizuotos knygų atsiėmimo ir grąžinimo spintelės, veikiančios 24 valandas per parą. Idealus sprendimas viešosioms ir akademinėms bibliotekoms.",
    },
    {
      title: "RFID saugumo vartai bibliotekoms",
      features: ["RFID/EM/hibridiniai sprendimai", "Vagysčių prevencija", "Žmonių srauto apskaita"],
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/kd3cmak8_Screenshot_2026-01-26_131115-removebg-preview.png",
      alt: "RFID saugumo vartai bibliotekoms",
      seoDescription: "RFID ir EM technologijų saugumo vartai, užtikrinantys bibliotekos turto apsaugą ir lankytojų srauto apskaitą.",
    },
    {
      title: "Savitarnos sistemos bibliotekoms",
      features: ["Išdavimas ir grąžinimas be eilių", "RFID arba brūkšniniai kodai", "Mažesnė personalo apkrova"],
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/mogtp1yb_Screenshot_2026-01-26_131332-removebg-preview.png",
      alt: "Bibliotekų savitarnos sistemos",
      seoDescription: "Savitarnos terminalai leidžia lankytojams savarankiškai skolintis ir grąžinti knygas, sumažinant eiles ir personalo apkrovą.",
    },
    {
      title: "Inventorizacija ir fondo kontrolė",
      features: ["Greita inventorizacija", "Neteisingai padėtų knygų paieška", "Sinchronizacija su LMS"],
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/mdyld1g4_Screenshot_2026-01-26_131744-removebg-preview.png",
      alt: "Bibliotekų inventorizacijos įranga",
      seoDescription: "RFID inventorizacijos įranga greitai suskenuoja bibliotekos fondą ir sinchronizuoja duomenis su bibliotekų valdymo sistemomis.",
    },
    {
      title: "Bibliotekų procesų automatizavimas",
      features: ["Grąžinimo srautai ir logistika", "Rūšiavimas ir efektyvumas", "Darbo laiko optimizavimas"],
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/pot5n9nt_Screenshot_2026-01-26_131938-removebg-preview.png",
      alt: "Bibliotekų procesų automatizavimas",
      seoDescription: "Automatizuoti knygų rūšiavimo ir grąžinimo sprendimai, optimizuojantys bibliotekos darbo procesus ir personalą.",
    },
    {
      title: "Jutikliai ir patalpų monitoringas",
      features: ["Temperatūra / drėgmė / CO₂", "Apkrovos monitoringas", "Įspėjimai ir priežiūra"],
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/2kdetfkx_image.png",
      alt: "Bibliotekų patalpų monitoringo jutikliai",
      seoDescription: "IoT jutikliai stebi bibliotekos patalpų mikroklimatą: temperatūrą, drėgmę ir oro kokybę, užtikrinant optimalias sąlygas knygų saugojimui.",
    },
    {
      title: "Bibliotekų įranga ir priedai",
      features: ["Grąžinimo dėžės, įkrovimo stotys ir kt.", "Sprendimai viešosioms erdvėms", "Pritaikomi priedai"],
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/oea980nu_Screenshot_2026-01-26_132801-removebg-preview.png",
      alt: "Bibliotekų įranga ir priedai",
      seoDescription: "Papildoma bibliotekų įranga: grąžinimo dėžės, įkrovimo stotys, skaitymo stotys ir kiti priedai viešosioms erdvėms.",
    },
    {
      title: "Programinė įranga ir LMS integracija",
      features: ["LMS / SIP2 integracija", "Duomenų mainai ir saugumas", "Tvari architektūra"],
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/01j0sblo_multiple-application-hologram-icons-with-a-tablet-2026-01-11-08-32-35-utc.jpg",
      alt: "Bibliotekų programinė įranga ir integracija",
      seoDescription: "Programinės įrangos sprendimai su SIP2 protokolo palaikymu, integruojami su visomis pagrindinėmis bibliotekų valdymo sistemomis.",
    },
    {
      title: "Įrengimas, mokymai ir techninė pagalba",
      features: ["Projekto valdymas ir įrengimas", "Mokymai", "Ilgalaikė priežiūra"],
      image: "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/8gju7psy_Installation.jpeg",
      alt: "Bibliotekų įrangos įrengimas ir mokymai",
      seoDescription: "Pilnas paslaugų paketas: nuo projekto planavimo ir įrengimo iki personalo mokymų ir ilgalaikės techninės priežiūros.",
    },
  ],
  clientTypes: {
    title: "Bibliotekų ir savivaldybių partneriai",
    items: [
      "Viešosios bibliotekos",
      "Akademinės bibliotekos",
      "Savivaldybės",
      "Regioninės viešosios įstaigos",
    ],
  },
  references: {
    title: "Įgyvendinti projektai Lietuvoje",
    subtitle: "Mūsų sprendimai veikia bibliotekose ir viešosiose įstaigose visoje Latvijoje ir Lietuvoje",
  },
  localSignal: "Sprendimai jau įgyvendinti bibliotekose Lietuvoje ir Baltijos šalyse, bendradarbiaujant su savivaldybėmis, viešosiomis bibliotekomis ir akademinėmis institucijomis Vilniuje, Kaune, Klaipėdoje ir kituose miestuose.",
  cta: {
    title: "Planuojate bibliotekos modernizavimą?",
    subtitle: "Susisiekite su mumis, kad aptartume tinkamiausią sprendimą.",
    button1: "Susisiekti",
    button2: "Prašyti demonstracijos",
  },
  seoFaq: {
    title: "Dažniausiai užduodami klausimai apie bibliotekų sprendimus",
    items: [
      {
        question: "Kokie sprendimai siūlomi bibliotekoms?",
        answer: "Siūlome platų bibliotekų automatizavimo sprendimų asortimentą: knygų spintelės (Knygomatai®), RFID saugumo vartai, savitarnos sistemos, inventorizacijos įranga, procesų automatizavimas, jutikliai ir monitoringas, bei programinė įranga su LMS integracija.",
      },
      {
        question: "Ar sprendimai tinka savivaldybėms ir viešosioms įstaigoms?",
        answer: "Taip, mūsų sprendimai yra pritaikyti viešojo sektoriaus poreikiams ir atitinka viešųjų pirkimų reikalavimus. Dirbame su savivaldybėmis, regioninėmis bibliotekomis ir kitomis viešosiomis institucijomis Lietuvoje ir Baltijos šalyse.",
      },
      {
        question: "Ar galima integracija su esamomis bibliotekų sistemomis?",
        answer: "Taip, visi mūsų sprendimai palaiko SIP2 protokolą ir integruojami su pagrindinėmis bibliotekų valdymo sistemomis (LMS), tokiomis kaip LIBIS, Koha, Aleph ir kitomis.",
      },
      {
        question: "Ar sprendimai atitinka viešojo sektoriaus reikalavimus?",
        answer: "Taip, mūsų sprendimai atitinka ES ir Lietuvos viešojo sektoriaus reikalavimus, įskaitant duomenų apsaugos (GDPR), prieinamumo ir saugumo standartus.",
      },
      {
        question: "Kokia yra sprendimų kaina ir įgyvendinimo trukmė?",
        answer: "Kiekvienas projektas yra individualus. Kaina priklauso nuo pasirinktos įrangos ir apimties. Susisiekite su mumis dėl nemokamos konsultacijos ir individualaus pasiūlymo.",
      },
    ],
  },
};

// Hero illustration
export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_f09e65d5-1f65-4f2b-9e43-64e691dd79af/artifacts/5iaely6h_Bibliomats%20ilustracija.jpeg";
